import React from 'react';

class HandicapTypeSelect extends React.Component {

  constructor(props) {
		super(props);
		this.handicapTypeChange = this.handicapTypeChange.bind(this);
	}

	handicapTypeChange(event) {
		var handicapType = event.target.value;
		this.props.handicapTypeChange(handicapType);
	}

	render() {
		//console.log('HandicapTypeSelect: render');
		return (
			<select className={"form-control " + this.props.specificClass} id="handicapType"
				value={this.props.handicapType} onChange={this.handicapTypeChange}>
				
				<option>Aucun</option>
				<option>Cote TRS</option>
				<option>Cote SCAB</option>
				<option>Parties</option>
				<option>Moyenne</option>
				<option>Moy-500</option> {/* PUB LA BARAQUE - MOYENNE 500 PTS */}
			</select>
		);
	}

}

export default HandicapTypeSelect;

